// Module 19 (BL-380) G0 - display labels for the Events pack.
// UX pass 2026-10-25 (Val: "'Events Calendar' should just be 'Calendar' as a cross company standard for everyone"):
// the schedule calendar is called "Calendar" for every company. The Events pack no longer renames it, and the old
// per-company calendar name (orgs.schedule_calendar_label, all 'Schedule' live on 2026-10-24) is no longer shown.
// With the pack on, the menu shows Calendar as a parent with "Events" first and "Calendar" below it.

export const EVENTS_NAV_LABEL = 'Events';
export const CALENDAR_LABEL = 'Calendar';

// Module 19 (BL-380) G2 - the guest list. The database stores neutral values (pending / accepted / declined / maybe);
// the screen shows these words. DC-1: the screen says Yes / No / No reply / Maybe; the stored values and the words a CSV may use are unchanged.
export const GUESTS_SCREEN_LABEL = 'Guests & RSVP';
export const RSVP_STATUSES = ['pending', 'accepted', 'declined', 'maybe'];
const RSVP_LABELS = { pending: 'No reply', accepted: 'Yes', declined: 'No', maybe: 'Maybe' };
export function rsvpLabel(status) {
    return RSVP_LABELS[status] || RSVP_LABELS.pending;
}
// The platform's colour meanings (lib/colorMeaning): green = done, grey = no action needed, blue = follow up, yellow = someone's on it.
export const RSVP_TONES = { accepted: 'green', declined: 'grey', pending: 'blue', maybe: 'yellow' };
